import React from "react";

import Blogs from '../components/Blogs';
const BlogPage = () => {
    return (
        <>
            <Blogs isHorizontal={false} />
        </>
    );
}
 
export default BlogPage;